///home/cockskiz/new.greatlysocial.com/frontend/src/pages/dashboard/accounts/UpgradeModal.js
import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

export default function UpgradeModal ({ show, onHide }) {
  const navigate = useNavigate()

  if (!show) return null

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Account limit reached</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        <p className="mb-4">
          You’ve connected the maximum number of social accounts for your plan.
          Upgrade now to unlock more slots.
        </p>

        <Button
          variant="primary"
          className="w-100"
          onClick={() => {
            onHide()
            navigate('/dashboard/plans')
          }}
        >
          Upgrade my plan
        </Button>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Maybe later
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
